const initialState = {
  fleet: {},
  devices: [],
  total: 0,
};

const fleetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FLEET": {
      state = {
        ...state,
        fleet: action.payload,
      };
      return state;
    }
    case "VIEW_DEVICES": {
      const { devices, total } = action.payload;
      state = {
        ...state,
        devices,
        total,
      };
      return state;
    }
    case "ADD_NEW_DEVICES": {
      const { devices } = action.payload;
      state = {
        ...state,
        devices: [...state.devices, ...devices],
        total: state.total + devices.length,
      };
      return state;
    }
    case "WHITELIST_DEVICES": {
      const { devices } = action.payload;
      const updatedDevices = devices.map((imei) => {
        return {
          imei,
        };
      });
      state = {
        ...state,
        devices: [...state.devices, ...updatedDevices],
        total: state.total + updatedDevices.length,
      };
      return state;
    }
    case "BLACKLIST_DEVICES": {
      const { devices } = action.payload;
      const updatedDevices = state.devices.filter(
        (device) => !devices.includes(device.imei)
      );
      const updatedLength = state.total - devices.length;
      state = {
        ...state,
        devices: updatedDevices,
        total: updatedLength,
      };
      return state;
    }
    default:
      return state;
  }
};

export default fleetsReducer;
